var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / GE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-GE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,-1.33333333 L15.9996667,7.99966667 L29.3333333,8 L29.3333333,12 L15.9996667,11.9996667 L16,21.3333333 L12,21.3333333 L11.9996667,11.9996667 L-1.33333333,12 L-1.33333333,8 L11.9996667,7.99966667 L12,-1.33333333 L16,-1.33333333 Z",
    id: "Rectangle-2",
    fill: "#FF2B37",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6666667,2 L22.4,3.599 L24,3.33333333 L24,4.66666667 L22.4,4.4 L22.6666667,6 L21.3333333,6 L21.599,4.4 L20,4.66666667 L20,3.33333333 L21.599,3.599 L21.3333333,2 L22.6666667,2 Z",
    id: "Rectangle-742",
    fill: "#FD0D1B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,2 L6.4,3.599 L8,3.33333333 L8,4.66666667 L6.4,4.4 L6.66666667,6 L5.33333333,6 L5.599,4.4 L4,4.66666667 L4,3.33333333 L5.599,3.599 L5.33333333,2 L6.66666667,2 Z",
    id: "Rectangle-742",
    fill: "#FD0D1B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,14 L6.4,15.599 L8,15.3333333 L8,16.6666667 L6.4,16.4 L6.66666667,18 L5.33333333,18 L5.599,16.4 L4,16.6666667 L4,15.3333333 L5.599,15.599 L5.33333333,14 L6.66666667,14 Z",
    id: "Rectangle-742",
    fill: "#FD0D1B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6666667,14 L22.4,15.599 L24,15.3333333 L24,16.6666667 L22.4,16.4 L22.6666667,18 L21.3333333,18 L21.599,16.4 L20,16.6666667 L20,15.3333333 L21.599,15.599 L21.3333333,14 L22.6666667,14 Z",
    id: "Rectangle-742",
    fill: "#FD0D1B",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGe);
export default __webpack_public_path__ + "static/media/GE.f0a489a161fb70217283b3ad0d878015.svg";
export { ForwardRef as ReactComponent };